import { Caption } from '@moneyforward/ap-frontend-components';
import { ApprovingInvoiceReportFormInputResponse } from 'ap-openapi';
import { FC, memo } from 'react';

type DefaultFieldViewProps = {
  item: ApprovingInvoiceReportFormInputResponse;
  mismatchCaption?: string;
};

export const DefaultFieldView: FC<DefaultFieldViewProps> = memo(
  ({ item, mismatchCaption }) => {
    return (
      <>
        <div>{item?.input_values?.[0]?.label ?? ''}</div>
        {mismatchCaption && <Caption type='alert'>{mismatchCaption}</Caption>}
      </>
    );
  }
);

DefaultFieldView.displayName = 'DefaultFieldView';
